import { location } from 'cdui-js';
import { legalUrlKeepEmbed } from '../../../legal/legalEmbed';

/** URL 兜底参数名 */
export const OPEN_ACCOUNT_REOPEN_TIP_QUERY = 'reopenTip';

const REOPEN_TIP_STORAGE_KEY = 'difi_open_account_reopen_tip';

/** 内存标记（WebView 下比 query / sessionStorage 更稳） */
let reopenTipPending = false;

/** 进入开户文件页时打标：任意方式回到准备页都可重弹提示 */
export function markOpenAccountReopenTip() {
  reopenTipPending = true;
  try {
    sessionStorage.setItem(REOPEN_TIP_STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}

/**
 * 准备页消费重弹标记（内存 → sessionStorage → URL）。
 * 消费后清除，避免重复弹。
 */
export function consumeOpenAccountReopenTip(): boolean {
  let hit = reopenTipPending;
  reopenTipPending = false;

  try {
    if (sessionStorage.getItem(REOPEN_TIP_STORAGE_KEY) === '1') {
      sessionStorage.removeItem(REOPEN_TIP_STORAGE_KEY);
      hit = true;
    }
  } catch {
    /* ignore */
  }

  const q = location.query as Record<string, string | undefined>;
  if (q[OPEN_ACCOUNT_REOPEN_TIP_QUERY] === '1') {
    hit = true;
    clearOpenAccountReopenTipQuery();
  } else if (typeof window !== 'undefined') {
    try {
      if (new URL(window.location.href).searchParams.get(OPEN_ACCOUNT_REOPEN_TIP_QUERY) === '1') {
        hit = true;
        clearOpenAccountReopenTipQuery();
      }
    } catch {
      /* ignore */
    }
  }

  return hit;
}

/** 开户提示 → 开户文件列表页 */
export function routeToOpenAccountDocs() {
  markOpenAccountReopenTip();
  location.routeTo(legalUrlKeepEmbed('/open-account-docs'));
}

/**
 * 开户文件页返回开户流程（显式 route，不依赖浏览器历史）。
 * @param step 开户当前步；无效时回准备页 step=1
 */
export function routeBackFromOpenAccountDocs(step?: number) {
  markOpenAccountReopenTip();
  const s = typeof step === 'number' && Number.isFinite(step) && step > 0 ? Math.floor(step) : 1;
  location.routeTo(
    legalUrlKeepEmbed(`/open-progress?step=${s}&${OPEN_ACCOUNT_REOPEN_TIP_QUERY}=1`),
  );
}

/** 清掉 URL 上的 reopenTip（replaceState，避免 routeTo 重挂载） */
export function clearOpenAccountReopenTipQuery() {
  const q = location.query as Record<string, string | undefined>;
  const url = new URL(window.location.href);
  if (url.searchParams.get(OPEN_ACCOUNT_REOPEN_TIP_QUERY) !== '1' && q[OPEN_ACCOUNT_REOPEN_TIP_QUERY] !== '1') {
    return;
  }
  url.searchParams.delete(OPEN_ACCOUNT_REOPEN_TIP_QUERY);
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, '', next);
  delete q[OPEN_ACCOUNT_REOPEN_TIP_QUERY];
}
